<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 class="card-dados__titulo mb-0">Meus Itens</h3>

        <v-data-table :headers="colunas" :items="value" hide-actions
                      class="az-table-list tabela-meus-lotes"
                      no-data-text="Não há registro disponível">
            <template slot="items" slot-scope="props">
                <tr>
                    <td class="text-uppercase">
                        {{ props.item.loteItem }}
                    </td>
                    <td>
                        <ver-mais :tamanho="tamanho" :descricao="props.item.descricao"
                                  :itens="props.item.itens"/>
                    </td>
                    <td align="right">
                            {{props.item.valorVencedor | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                        <small v-if="props.item.valorAjustado" class="d-block">(negociado)</small>
                    </td>
                    <td align="right">
                        <span class="situacao-adjudicado" v-if="props.item.situacao === 'ADJUDICADO'">
                            <i class="fas fa-check mr-1" aria-hidden="true"/> Adjudicado
                        </span>
                        <div v-else>
                            <v-tooltip top v-if="props.item.motivo" class="botao-motivo">
                                <a slot="activator">
                                    {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                                    <i class="fas fa-comment" aria-hidden="true"/>
                                </a>
                                {{ props.item.motivo }}
                            </v-tooltip>
                            <span v-else>
                                {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                            </span>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesItensELotes} from '@/core/constants'

export default {
    name: 'MeusLotesItensVencedores',
    props: {
        value: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        }
    },
    data() {
        return {
            colunas: [
                {
                    align: 'left',
                    sortable: true,
                    width: '10px',
                    class: 'primary--text',
                    text: 'Seq',
                    value: 'loteItem'
                },
                {
                    align: 'left',
                    value: 'descricao',
                    class: 'primary--text',
                    text: 'Descrição',
                    width: '100px',
                    sortable: false
                },
                {
                    sortable: false,
                    text: this.criterioJulgamento === 'MENOR_PRECO' ? 'Valor Vencedor' : 'Desconto Vencedor',
                    align: 'right',
                    width: '60px',
                    value: 'valorVencedor',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: 'Situação',
                    align: 'right',
                    width: '60px',
                    value: 'situacao',
                    class: 'primary--text'
                }
            ],
            situacoesItensELotes,
            tamanho: null
        }
    },
    computed: {
        ...mapState(['loki']),
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .2 * window.innerWidth
        },
        formatarValorOuPercentual(valor){
            if(this.criterioJulgamento === 'MAIOR_DESCONTO')
                return `${valor}${this.simboloCriterioJulgamento}`

            return `${this.simboloCriterioJulgamento} ${valor}`
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped lang="stylus">
    .tabela-meus-lotes
        padding 16px

    @media (max-width 720px)
        .tabela-meus-lotes
            padding 0

            td:nth-of-type(1):before
                content "Sequência:"
                text-transform capitalize

            td:nth-of-type(2):before
                content "Descrição:"

            td:nth-of-type(3):before
                content "Valor Vencedor:"

            td:nth-of-type(4):before
                content "Situação:"

            td:nth-of-type(3)
                text-align left

            td:nth-of-type(4)
                text-align left
</style>
